import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'


const Careers = () => {
  const navigate=useNavigate();
  useEffect(() => {
    window.scrollTo(900, 900);
  }, []);

  return (
<div className='container' style={{minHeight:"100vh"}}>
      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">

    <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{maxWidth: 600}}>
      <h5 className="fw-bold text-primary text-uppercase">Careers</h5>
      <h1 className="mb-0">If You Want To<br/>Join With Us</h1>
    </div>
    </div>

<div className="table-responsive" style={{marginTop:"-50px"}} >


<table className="table table-bordered  table-hover">
  <thead>
    <tr className='bg-dark text-light'>
      <th scope='col'>Job ID</th>
      <th scope='col'>Position</th>
      <th scope='col'>Key Skills</th>
      <th scope='col'>Experience</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <th scope="row">DN1</th>
      <td>JuniorDot Net Programmer</td>
      <td>VB.net/ C#.net /ASP.net and Sql Server</td>
      <td>0-5 Years</td>
    </tr>
    <tr>
      <th scope="row">DN2</th>
      <td>Senior Dot Net Programmer</td>
      <td className="active">VB.net/ C#.net /ASP.net and Sql Server</td>
      <td className="active">5-10 Years</td>
    </tr>
    <tr>
      <th scope="row">DN3</th>
      <td>Android Developer</td>
      <td> Android SDK, JSON, Mobile Development, REST Software Development, Core Java</td>
      <td className="active">1-5 Years</td>
    </tr>
    <tr>
      <th scope="row">DN4</th>
      <td>UI Graphics Designer</td>
      <td>Photoshop, illustrator, Mock tools</td>
      <td>1-2 Years</td>
    </tr>
    <tr>
      <th scope="row">DN5</th>
      <td>Junior Marketing Manager</td>
      <td>Software Marketing Industry Experience</td>
      <td>0-2 Years</td>
    </tr>
    <tr>
      <th scope="row">DN6</th>
      <td>Software Trainer</td>
      <td>Software Training Experience</td>
      <td>0-2 Years</td>
    </tr>
    <tr>
      <th scope="row">DN6</th>
      <td>Computer Service person</td>
      <td>Computer Service Experience</td>
      <td>0-1 Years</td>
    </tr>
  </tbody>
</table>
<div className='d-flex justify-content-center align-items-center' style={{minHeight:"100px"}}> 
<button className='btn btn-primary w-50' style={{borderRadius:"10px",boxShadow:"rgba(0, 0, 0, 0.25) 0px 10px 20px, rgba(0, 0, 0, 0.12) 0px 10px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px"}} onClick={()=>navigate("/contact")}>Apply</button>
</div>
    </div>
    </div>

  )
}

export default Careers